export const GET_RESELLER_INFO = 'GET_RESELLER_INFO';
export const GET_RESELLER_INFO_RESULT = 'GET_RESELLER_INFO_RESULT';